<template>
  <v-card>
    <v-toolbar card>
      <v-icon>people</v-icon>
      <v-toolbar-title class="font-weight-light">
        Propietarios / Inquilinos
        {{ inmuebleUsers ? `[${Object.entries(inmuebleUsers).length}]` : "" }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn small fab dark :color="temaColor">
        <v-icon @click="buscaUsuario" dark>add</v-icon>
      </v-btn> -->
    </v-toolbar>
    <v-card-text class="px-0">
      <v-container grid-list-md text-xs-center v-if="inmuebleUsers">
        <v-layout row wrap>
          <v-flex xs4 v-for="(users, i) in inmuebleUsers" :key="i">
            <v-card
              :color="
                    users.mayor65
                      ? 'teal lighten-5'
                      : users.discapacidad
                      ? 'orange lighten-5'
                      : 'grey lighten-4'
                  "
              class="elevation-3"
            >
              <v-card-title
                :class="
                      users.mayor65
                        ? 'py-0 teal lighten-4'
                        : users.discapacidad
                        ? 'py-0 orange lighten-4'
                        : 'py-0 grey lighten-3'
                    "
              >
                <!-- <v-btn small outline fab color="primary" @click="editarUsuario(users.id)">
                  <v-icon>create</v-icon>
                </v-btn> -->
                <template v-if="users.mayor65 || users.discapacidad">
                  <v-tooltip top>
                    <v-icon
                      slot="activator"
                      v-if="users.discapacidad"
                    >mdi-wheelchair-accessibility</v-icon>
                    <span>Discapacidad</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <v-icon slot="activator" v-if="users.mayor65">mdi-timelapse</v-icon>
                    <span>Mayor 65 Años</span>
                  </v-tooltip>
                </template>
                <v-spacer></v-spacer>
                <router-link :to="`/dashboard/perfil/${users.id}`">
                  {{
                    users.nombreApellidos || "-"
                  }}
                </router-link>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="px-2 py-0">
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs7 class="py-0">
                      <v-radio-group v-model="users.tipo">
                        <v-radio label="Propietario" value="0"></v-radio>
                        <v-radio label="Inquilino" value="1"></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs5 v-if="users.tipo === '0'">
                      <v-text-field
                        class="py-3"
                        suffix="%"
                        type="number"
                        max="100"
                        label="% Propiedad"
                        v-model="users.cuota"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-divider class="py-0"></v-divider>

                <!-- <v-flex xs12 class="py-0">
                  <v-layout row wrap>
                    <v-flex xs8 class="py-0">
                      <v-combobox
                        @change="changePadron(i)"
                        v-model="inmuebleUsersFilter[i]"
                        :items="empadronadoItems"
                        item-text="text"
                        item-value="value"
                      ></v-combobox>
                    </v-flex>
                    <v-flex xs4 text-xs-right>
                      <v-btn small outline fab color="error" @click="deleteUsuario(users.id)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 v-if="users.empadronado">
                      <v-checkbox
                        class="py-0"
                        label="Volante empadronamiento"
                        v-model="users.volante"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-flex> -->
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <!-- <v-layout row wrap v-if="mostrarAnexo4">
          <v-flex xs12>
            <v-tooltip top>
              <v-checkbox
                slot="activator"
                class="py-0"
                label="Anexo IV - Discapacidad / Mayor 65 Años"
                v-model="inmuebleDatos.anexo4"
              ></v-checkbox>
              <span>Marcar si se ha cumplimentado el Anexo IV</span>
            </v-tooltip>
          </v-flex>
        </v-layout> -->
      </v-container>
      <v-container grid-list-md text-xs-center v-else>
        <p class="text-xs-center">Ningún Propietario / Inquilino seleccionado</p>
      </v-container>
    </v-card-text>

    <!-- <v-card-actions>
      <v-tooltip top>
        <v-checkbox
          slot="activator"
          class="py-0"
          label="Anexo III - Renta inferior al máximo"
          v-model="inmuebleDatos.cumpleRequisitoEcon"
        ></v-checkbox>
        <span>
          Marcar si cumple con el requisito de renta máxima para 35% de
          ayuda Adicional
        </span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-btn color="success" @click.stop="inmuebleUserUpdate">
        Guardar
        <v-icon right dark>save</v-icon>
      </v-btn>
    </v-card-actions> -->
    
  </v-card>
</template>

<script>
export default {
  props: ["usuarios", "refCatastral", "idInmueble", "debug"],
  data () {
    return {
      inmuebleUsers: null
    }
  },

  mounted() {
    this.inmuebleUsers = Object.assign({}, this.usuarios);
  },

  watch: {
    usuarios() {
      this.inmuebleUsers = Object.assign({}, this.usuarios);
    }
  },

  methods: {
    dataUsers() {
      if (!this.usuarios) {
        console.log('Sin inmuebleUsers')
        return;
      }
      let result = [];
      this.usuarios.forEach(user => {
        const id = user.id;
        const userConsolidado = this.arrayUsers.filter(u => u.idx === id)[0];
        let datos = user;
        if (userConsolidado) {
          const usrData = userConsolidado.data;
          // const especial = this.$store.getters.isMayor65OrDiscapacidad(id);
          datos.email = usrData.admin.email || '';

        }
      });
    },

    deleteUsuario(idx) {
      /* const array = this.inmuebleUsers.map(item => item.idx)
            const indice = array.indexOf(idx); // obtenemos el indice
            this.inmuebleUsers.splice(indice, 1) */
      const payload = {
        refCatastral: this.refCatastral,
        idInmueble: this.idInmueble,
        inmuebleUser: this.inmuebleDatos.refCat,
        idUser: idx
      };
      this.$store.dispatch(
        "deleteUserInmueble",
        payload
      ); /* .then(() => {
                this.updateUsers()
                this.hecho = true
            }) */
    }

  },

  computed: {
    temaColor() {
      return this.$store.getters.getTemaColorAdminUI;
    },

    arrayUsers() {
      return this.$store.getters.getUsersArray;
    }
  }
}
</script>
